<template>
  <div class="sidebar h-full overflow-hidden relative z-[5]">
    <div class="friends-sidebar w-[280px] h-full overflow-hidden relative" :class="{'friends-in-room': cur_room_id}">
      <div class="wh-full mr-auto overflow-hidden">
        <div
          class="friends-tab-pane h-full"
          v-delegate="{
            click: {
              'open-user-card': {
                handler: handleClickMember
              }
            },
            contextmenu: {
              'open-user-menu': {
                handler: handleUserContextMenu
              }
            }
          }"
        >
          <!-- 房间成员 -->
          <keep-alive>
            <RoomMembers v-if="active_sidebar_tab == 'room'" ref="room-members" />
          </keep-alive>

          <!-- 我的好友 -->
          <template v-if="active_sidebar_tab === 'friends'">
            <!-- 有好友状态 或 数据请求中骨架状态 -->
            <FriendsMembers
              v-if="!isCompleted || hasFriends"
              key="search-bar"
              :topFriendList="topFriendList"
              :friends_data="friends_data"
              :isCompleted="isCompleted"
              @hideFriendBlock="hideFriendBlock"
              @getRecommendFriend="handleGetRecommendFriend"
            />
            <!-- 无好友状态 -->
            <NoFriendsWrapper v-else ref="friendScrollList" @hide-friend-block="hideFriendBlock"/>
          </template>

          <!-- 最近消息 -->
          <RecentMsgs
            v-if="active_sidebar_tab === 'recent-msg'"
            @open-private-chat="handleClickRecentMsg"
            @hideFriendBlock="hideFriendBlock"
            :init_open_user_id="init_open_user_id"
          />
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import Avatar from '_com/func/Avatar'
import RedNum from "_com/func/RedNum.vue";
const NoFriendsWrapper = () => import('./sidebar-friends/NoFriendsWrapper.vue')
const RecentMsgs = () => import('./sidebar-friends/RecentMsgs.vue')
const RoomMembers = () => import('./sidebar-friends/RoomMembers.vue')
import FriendsMembers from './sidebar-friends/FriendsMembers.vue'
import { NO_PERMISSION_TYPE } from '_lib/constants/no-permission';

import { mapGetters, mapMutations, mapActions } from 'vuex'
import EventBus from '_lib/EventBus'
import {
  checkLoginStatusAsync,
  deepCopy,
  moveElementToFront
} from "_lib/utils/utils";
import {
  getOfficialMessageIds,
  isSingleUser
} from "_lib/utils/utilsFriend";
import { getUserAddminMenu } from '_lib/userMenu';
import { getMsgDesc } from '_lib/MessageNoticeText'

import userMenuMixin from '_mixin/userMenu';
import updateFriendsListMixin from '../mixin/updateFriendsList';
import recommendFriendsMixin from '_mixin/recommendFriendsMixin'
import {
  inviteFriendJoinRoomOrChannel
} from '_api/invite'
import { 
  getFriendList, 
  addFriend,
  getTopFriendList,
  getSteamFriends,
  getUserInfo
} from "_api/friend";
import { setSysNotifyTop, updatePrivateReadState } from '_api/message'
import { clearPostUnread } from '_api/bbs'
import { addRoleUsers, revokeRoleFromUsers } from "_api/role";
import { updateTopFriendList } from '_api/friend'
import { integrationFriends } from '_api/integration'
import { getPostMsgUnread } from '_api/bbs'
import { getUserGameIds } from "_api/account"

import { ROLE_TYPES } from '@/common/constants/role';
import { NEW_OFFICIAL_MESSAGE_ID } from '@/common/constants/message';
import { IM_MSG_TYPE } from '@/common/constants/IM.ts'
import badger from "_lib/Badger"
import { ADD_FRIEND_ADD_DIALOG, ADD_RECOMMEND_FRIEND_LIST, SOCKET_FRIEND_UPDATE_ALT_TYPE } from '_lib/constants/friend'
import { decimalToHexColor } from '_lib/utils/utilsColor'

import steam from "@/common/steam"

const TABS_LIST = [
  {
    id: 'room',
    name: '房间成员',
    require: 'room',
  },
  {
    id: 'friends',
    name: '我的好友',
  },
  {
    id: 'recent-msg',
    name: '最近消息',
  }
]

export default {
  name: 'SideBarFriends',
  mixins: [
    userMenuMixin,
    updateFriendsListMixin,
    recommendFriendsMixin,
  ],
  provide() {
    return {
      localUserCardMenuHandler: this.localUserCardMenuHandler,
      localPrivateChatHandler: this.localPrivateChatHandler,
      inviteFriend: this.inviteFriend,
      sendAddFriend: this.sendAddFriend,
    }
  }, 
  data () {
    return {
      friendSearch: '',
      friends_data: {
        online_friends: [],
        offline_friends: [],
        rooms: [],
        single_user_rooms: [],
        steam_friends: []
      },
      room_hide_bl: {},
      isFristExpendRecommend: false,
      isClient: false,
      isCompleted: false, // 好友列表数据加载是否完成
      topFriendList: [],
      staticFriend: true,
      room_info:{},
      TABS_LIST,
      init_open_user_id: 0,

      steamNetHookNum: 0,
      offlineTrayCount: 0,
    }
  },
  computed: {
    ...mapGetters([
      'user_info',
      'is_login',
      'cur_room_data',
      "channel_data",
      'cur_text_channel_data',
      'cur_channel_data',
      'friends_map',
      'showAddFriendModal',
      'cur_roles_list',
      'cur_my_roles',
      'online_state',
      'show_friend_sidebar',
      'show_right_bar_anmation',
      'friend_online_cnt',
      'recent_msg_list',
      'stranger_msg_list',
      'show_theme_manager',
      'api_poll_interval',
      'setting_data',
      'post_msg_unread',
      'active_user_card',
      'cur_private_user',
      'cur_room_whole_data',
      'active_sidebar_tab',
      'recommend_friends',
      'user_account_settings',
      'steam_id',
      'recent_msg_count',
      'recommend_friends_over',
    ]),
    isHideFriendBlock () {
      return this.setting_data.hide_friend_types
    },
    cur_room_id () {
      return this.$route.params.room_id
    },
    hasJoinChannel () {
      return this.cur_text_channel_data.channel_id || this.cur_channel_data.channel_id
    },
    hasFriends() {
      return Object.keys(this.friends_map).length > 0
    },
    searchFriends () {
      if (this.friendSearch) {
        return Object.values(this.friends_map).filter((v) => {
          return ('' + v.user_id).includes(this.friendSearch) || v.nickname.toLowerCase().includes(this.friendSearch.toLowerCase()) || v.remarks.toLowerCase().includes(this.friendSearch.toLowerCase());
        });
      } else {
        return [];
      }
    },
    unreadMessagesNum () {
      let num = this.recent_msg_count
      // this.recent_msg_list.forEach(v => {
      //   num += v.new_msg_count || 0
      // })
      !process.env.IS_CLIENT && badger.updatePMUnreadCount(num)
      return num
    },
    tabBarTranslate() {
      let ids = TABS_LIST
        .filter(({require}) => require !== 'room' || !!this.cur_room_id)
        .map(({id}) => id)
      return ids.indexOf(this.active_sidebar_tab) * 80
    }
  },
  watch: {
    cur_room_id: {
      handler(cur_room_id) {
        if (cur_room_id) {
          this.SET_ACTIVE_SIDEBAR_TAB('room')
        } else {
          this.SET_ACTIVE_SIDEBAR_TAB('friends')
          this.SET_SHOW_FRIEND_SIDEBAR(false)
          this.SET_LAST_SHOW_FRIEND_SIDEBAR(true)
        }
      },
      immediate: true
    },
    friends_map: {
      handler(v) {
        let memberList = Object.values(v)
        let cnt = memberList.reduce((accumulator, currentValue) => accumulator + (currentValue.online_state > 0 ? 1 : 0), 0)
        this.SET_FRIEND_ONLINE_CNT(cnt)

        // 推荐好友过滤已添加的好友
        if (this.recommend_friends) {
          let _recommend_friends = this.recommend_friends.filter((u) => {
            return !v[u.user_id]
          })
          if (_recommend_friends.length !== this.recommend_friends.length) {
            this.SET_RECOMMEND_FRIENDS(_recommend_friends)
          }
        }

        // 找出memberList和topFriendList的交集
        let topFriendList = this.topFriendList.filter((u) => {
          return v[u.user_id]
        })
        // 更新this.topFriendList的remarks的字段
        topFriendList.forEach((u) => {
          u.remarks = v[u.user_id].remarks
        })
      },
      deep: true,
      immediate: true,
    },
    'channel_data.channel_id': {
      handler(v, oldV) {
        if (this._new_channel_id !== v) {
          this.changeWithMe(v, true)
        }
        if (this._old_channel_id !== oldV) {
          this.changeWithMe(oldV, false)
        }
        this._new_channel_id = v
        this._old_channel_id = oldV
      },
    },
  },
  created () {
    this.initIntegrationData()
  },
  mounted () {
    // 好友状态更新推送
    EventBus.$on('SOCKET_FRIENDS_STATE_UPDATE', this.handleFriendStatePush)

    EventBus.$on('Update_Friend_List', this.getFriendList)
    EventBus.$on("Jump_Private_Chat", this.localPrivateChatHandler);
    // 监听弹出私聊弹窗事件(没有event)
    EventBus.$on("Open_Private_Chat", this.openChatHandler);
    // ws重连更新
    EventBus.$on('Socket_Connect', this.getFriendList)
    // 邀请好友 进入房间或频道
    EventBus.$on('Invite_Friend_To_Room', this.inviteFriend);

    EventBus.$on('Add_Friend_Top', this.setFriendTop)
    EventBus.$on('Cancel_Friend_Top', this.cancelFriendTop)
    EventBus.$on('Refresh_Post_Full_Msg', this.getPostMsgUnread)

    EventBus.$on("Steam_Acount_Change", this.handlerSteamFriendsList)
    EventBus.$on("Steam:Change_Steam_Friends", this.changeSteamFriends)
    EventBus.$on("Steam:Get_Steam_Friends_Message", this.getSteamFriendsMessage)
    EventBus.$on("Setting:Steam_Nethook_Changed", this.changeSettingSteamNetHook)
    EventBus.$on("steam:switch-steam-account", this.switchSteamAccount)
    EventBus.$on('Steam:Change_Part_Steam_Friends', this.changePartSteamFriends)
  },
  beforeDestroy () {
    EventBus.$off('SOCKET_FRIENDS_STATE_UPDATE', this.handleFriendStatePush)

    EventBus.$off('Update_Friend_List', this.getFriendList)
    EventBus.$off("Jump_Private_Chat", this.localPrivateChatHandler);
    EventBus.$off("Open_Private_Chat", this.openChatHandler);
    EventBus.$off('Socket_Connect', this.getFriendList)
    EventBus.$off('Invite_Friend_To_Room', this.inviteFriend);
    EventBus.$off('Add_Friend_Top', this.setFriendTop)
    EventBus.$off('Cancel_Friend_Top', this.cancelFriendTop)
    EventBus.$off('Refresh_Post_Full_Msg', this.getPostMsgUnread)

    EventBus.$off("Steam_Acount_Change", this.handlerSteamFriendsList)
    EventBus.$off("Steam:Change_Steam_Friends", this.changeSteamFriends)
    EventBus.$off("Steam:Get_Steam_Friends_Message", this.getSteamFriendsMessage)
    EventBus.$off("Setting:Steam_Nethook_Changed", this.changeSettingSteamNetHook)
    EventBus.$off("steam:switch-steam-account", this.switchSteamAccount)
    EventBus.$off('Steam:Change_Part_Steam_Friends', this.changePartSteamFriends)

    clearTimeout(this.member_timer)
    clearTimeout(this._getFriendTimeout)
    clearTimeout(this.recent_msg_hover_timer)
    clearTimeout(this.checkTimer)
    clearTimeout(this._clickTimeout)
    clearInterval(this.steamTimer)
  },
  methods: {
    ...mapMutations([
      'SET_FRIENDS',
      'SET_ADD_FRIEND_MODAL',
      'SET_CUR_ROOM_DATA',
      'SET_SHOW_FRIEND_SIDEBAR',
      'SET_FRIEND_ONLINE_CNT',
      'SET_ACTIVE_SIDEBAR_TAB',
      'SET_RECENT_MSG_LIST',
      'SET_RECENT_MSG_COUNT',
      'SET_POST_MSG_UNREAD',
      'SET_TOP_FRIEND_ID',
      'SET_RECOMMEND_FRIENDS',
      'SET_ROOM_MEMBER_NUM',
      'SET_DISCOVER_ENTER_WAY',
      'SET_STEAM_ID',
      'SET_RECOMMEND_FRIENDS_OVER',
      'SET_LAST_SHOW_FRIEND_SIDEBAR',
    ]),
    ...mapActions([
      'SET_SETTING_DATA_PARAM',
    ]),
    async initIntegrationData() {
      if(!await checkLoginStatusAsync(this.$route.params.no_remind)){
        this.isCompleted = true
        this.getRecentDown = true
        return
      }
      let res = await integrationFriends()
      if (this._isDestroyed) return
      if (res.data.status === 'ok') {
        let result = res.data.result

        // 好友列表数据处理
        this.handleFriends(result.friend_list)
        this.startFriendListInterval()

        this.SET_RECENT_MSG_COUNT(result.talk_list_unread_count || 0)
        EventBus.$emit('initOfflineTrayMsg')
        this.getRecentDown = true

        // 置顶好友处理
        this.topFriendList = result.top_friends;

        // 推荐好友处理
        const is_recommend_hide = this.isHideFriendBlock['recommend']
        this.handleRecommendFriend(result.recommend_friends)
        if (is_recommend_hide) {
          this.getRecommendFriendUntilCanScroll()
          this.isFristExpendRecommend = true
        }
        this.isCompleted = true
        this.getPostMsgUnread(true)

        // Steam好友处理
        if(this.user_account_settings.allow_steam_nethook) {
          steam.init(true)
          this.getSteamFriendsList()
        }
      }
    },
    
    handleChangeActiveTab(tab) {
      this.SET_ACTIVE_SIDEBAR_TAB(tab)
    },
    handleGetRecommendFriend (cb) {
      if (this.recommend_friends_over) {
        cb && cb()
        return
      }
      this.getRecommendFriend(true).finally(() => {
        cb && cb()
      })
    },
    getRecommendFriendUntilCanScroll() {
      // 好友推荐功能是一个下拉加载的列表，但是初始请求出来的长度不一定能够滚动，这时候再请求一次来填满
      if (this.recommend_friends_over) return
      
      const checkHeightAndRequest = () => {
        let friendScrollList = this.$refs.friendScrollList
        if (!friendScrollList) return
        // friendScrollList 会出现 clientHeight 为 0，但是内部元素有高度的情况，这个轮询来处理
        if (friendScrollList.clientHeight === 0) {
          clearTimeout(this.checkTimer)
          this.checkTimer = setTimeout(checkHeightAndRequest, 200)
          return
        }
        
        let children = friendScrollList.children
        let innerHeight = 0
        for (let child of children) {
          innerHeight += child.getBoundingClientRect().height
        }
        let fillHeight = friendScrollList.clientHeight - innerHeight
        if (fillHeight > 0) {
          const recommendFriendItemHeight = 50
          let count = Math.ceil(fillHeight / recommendFriendItemHeight)
          this.getRecommendFriend(true, Math.max(20, count))
        }
      }
      
      this.$nextTick(checkHeightAndRequest)
    },

    async getPostMsgUnread (init = false, toFront = false, type) {
      const { data } = await getPostMsgUnread()
      if (this._isDestroyed) return
      if (data.status == 'ok') {
        const result = data.result
        let post_msg_unread = {
          award: 0,
          comment: 0,
          at: 0,
        }
        if (this.user_account_settings.push_interaction_msg) {
          post_msg_unread = {
            award: result.award,
            comment: result.comment,
            at: result.at,
          }
        }
        const target = this.recent_msg_list.find(item => item.user_id == NEW_OFFICIAL_MESSAGE_ID.heychat_interaction_msg)
        if (target) {
          const new_count = this.user_account_settings.push_interaction_msg ? result.award + result.comment + result.at : 0
          target.new_msg_count = new_count
          this.setRecentMsg(target, toFront)
        }
        if (init || (type === 'add')) {
          const total = post_msg_unread.award + post_msg_unread.comment + post_msg_unread.at
          this.SET_RECENT_MSG_COUNT(this.recent_msg_count + total)
        } else if (type === 'remove') {
          const total = this.post_msg_unread.award + this.post_msg_unread.comment + this.post_msg_unread.at
          this.SET_RECENT_MSG_COUNT(this.recent_msg_count - total)
        }
        this.SET_POST_MSG_UNREAD(post_msg_unread)
      }
    },


    getLastMsgText (msg) {
      const msg_type = msg.msg_type
      switch (msg_type) {
        case IM_MSG_TYPE.sticker:
          return '[表情]'
        case IM_MSG_TYPE.img:
          return '[图片]'
        case IM_MSG_TYPE.uploadFile:
          return '[文件]'
        case IM_MSG_TYPE.teamCard:  
          return '[组队卡片]'
        case IM_MSG_TYPE.miniProgram:
          return '[小程序]'
        case IM_MSG_TYPE.customCard:
          return '[卡片消息]'
        case IM_MSG_TYPE.miniProDetail:
          return `[小程序]${msg.mini_pro_detail.title}`
      }
      const text = msg._origin_msg || msg.msg
      let imageUrlRegex = /!\[.*?\]\((https|http):\/\/[a-zA-Z0-9]+\.(max-c|maxjia)\.com\/.*?\)/g;
      const text_res = text.replace(imageUrlRegex, '「图片」');
      if (msg_type === IM_MSG_TYPE.textAndImg) {
        return text_res + (msg.img ? ' [图片]' : '')
      }
      return text_res
    },
    // 好友状态更新，只有当前在最近消息下面需要刷新
    handleFriendStatePush (data) {
      if (this.active_sidebar_tab !== 'recent-msg') return
      let d = data.data, alt_type = d.alt_type, friends = d.friends
      if (d.friends && d.friends.length > 0) {
        if (alt_type === SOCKET_FRIEND_UPDATE_ALT_TYPE.UPDATE) {
          const user = this.recent_msg_list.find(u => u.user_id == d.friends[0].user_id)
          if (user) {
            user.state = d.friends[0].state
          }
          this.SET_RECENT_MSG_LIST(this.recent_msg_list)
        } else if(alt_type === SOCKET_FRIEND_UPDATE_ALT_TYPE.ADD) {
          this.friends_data.steam_friends = steam.formatResultList(steam.resultList, friends)
        }
      }
    },
    checkHasRecent (user_id) {
      if (this.active_sidebar_tab !== 'recent-msg') return
      const target = this.recent_msg_list.find(item => item.user_id == user_id)
      if (!target) {
        EventBus.$emit('Refresh:RecentMsg')
      }
      return target
    },
    setRecentMsg (target, toFront = false) {
      const index = this.recent_msg_list.findIndex(item => item.user_id == target.user_id)
      this.recent_msg_list[index] = target
      this.SET_RECENT_MSG_LIST(toFront ? moveElementToFront(this.recent_msg_list, index) : this.recent_msg_list)
    },
    inviteFriend (friend_id, force_invite = false) {
      let channel_data = this.$route.name === 'room' && this.cur_text_channel_data.channel_id ? this.cur_text_channel_data : this.cur_channel_data
      if (this.cur_room_data.room_id && (channel_data.room_id != this.cur_room_data.room_id)) {
        channel_data = {}
      }
      if (!force_invite && !this.$permission.judge('CreateInvitation', channel_data)) {
        this.$toast.no_permission(NO_PERMISSION_TYPE.ROOM_NO_ROLE)
        return
      }
      if (this.invite_lock) {
        return
      }
      this.invite_lock = false

      let data = {
        user_id: this.user_info.user_id,
        to_user_id: friend_id,
        room_id: channel_data.room_id || this.cur_room_data.room_id,
      }
      // 所在频道在当前房间内才进行频道邀请
      if (channel_data.channel_id) {
        data.channel_id = channel_data.channel_id
      }

      inviteFriendJoinRoomOrChannel({}, data).then((res) => {
        this.invite_lock = false
        if (res.data.status === 'ok') {
          this.$toast.success('已发送邀请')
        } else if ((res.data.error_type === 'no_permission') && data.channel_id) {
          EventBus.$dynamic('NoPremChannelDialog', {
            channel: channel_data,
            origin_channel_id: data.channel_id,
            to_user_ids: [friend_id],
            type: 'invite',
          })
        }
      })
    },
    joinChannel (data) {
      let { room_id, channel_id, user } = data
      EventBus.$jump({
        channel_id,
        room_id,
        nickname: user.nickname,
        user_id: user.user_id,
      }, 'friends-list-follow')
      if(this.$route.name === 'home') this.SET_DISCOVER_ENTER_WAY('friends-list-follow')
    },
    async getFriendList () {
      const res = await getFriendList();
      if (this._isDestroyed) return
      if (res.data.status === 'ok') {
        this.handleFriends(res.data.result.friends)
        this.startFriendListInterval()
        return true;
      }
      return false;
    },
    startFriendListInterval() {
      clearTimeout(this._getFriendTimeout)
        if (!this._isDestroyed) {
          let interval = this.api_poll_interval('friend_list', 30)
          this._getFriendTimeout = setTimeout(() => {
            this.getFriendList()
          }, interval * 1000);
        }
    },
    
    handleRecommendFriend(d) {
      this.SET_RECOMMEND_FRIENDS(d)
      if (d.length < 20) {
        this.SET_RECOMMEND_FRIENDS_OVER(true)
      }
    },

    async getTopFriendList() {
      const res = await getTopFriendList();
      if (this._isDestroyed) return
      if (res.data.status == 'ok') {
        this.topFriendList = res.data.result.friends;
        return true;
      }
      return false
    },
    setFriendTop(friend) {
      if (this.top_friend_id.includes(friend.user_id)) {
        return
      }
      this.topFriendList.unshift(friend)
      this.SET_TOP_FRIEND_ID(this.topFriendList.map(friend => friend.user_id))
      updateTopFriendList({}, { friend_ids: this.top_friend_id })
    },
    cancelFriendTop(friend) {
      this.topFriendList = this.topFriendList.filter(item => item.user_id != friend.user_id)
      this.SET_TOP_FRIEND_ID(this.topFriendList.map(friend => friend.user_id))
      updateTopFriendList({}, { friend_ids: this.top_friend_id })
    },
    handleFriends(r) {
      
      this.friends_data = {
        online_friends: [],
        offline_friends: [],
        rooms: [],
        single_user_rooms: [],
        steam_friends: []
      }
      if (!r) return

      let map = {}
      for (let room of r.rooms || []) {
        if (isSingleUser(room.channels)) {
          this.friends_data.single_user_rooms.push(room)
        } else {
          this.friends_data.rooms.push(room)
        }
        for (let channel of room.channels || []) {
          for (let friend of channel.friends || []) {
            friend.room_name = room.room_name
            friend.room_id = room.room_id
            friend.room_avatar = room.room_avatar
            friend.channel_id = channel.channel_id == '0' ? '' : channel.channel_id
            friend.channel_name = channel.channel_name
            friend.show_join_room = room.is_available == 1
            map[friend.user_id] = friend
          }
        }
      }
      if (r.friends) {
        r.friends.forEach((v) => {
          if (v.state == 0) {
            this.friends_data.offline_friends.push(v)
          } else {
            this.friends_data.online_friends.push(v)
          }
          map[v.user_id] = v
        })
      }

      this.friends_data.steam_friends = steam.sliceResultList || []

      this.SET_FRIENDS(map)
      setTimeout(() => {
        this.$forceUpdate()
      })
    },
    sendAddFriend (id, noToast, fromRecommend) {
      if (!/^[0-9]{6,11}$/g.test(id)) {
        this.$toast.error('请输入小黑盒数字ID')
        return new Promise((_, reject) => {
          reject('TypeError');
        })
      }
      if (this.friend_lock) {
        return new Promise((_, reject) => {
          reject('NoReturn');
        })
      }
      this.friend_lock = true
      return addFriend({}, {
        friend_ids: [ +id ],
        source: fromRecommend ? ADD_RECOMMEND_FRIEND_LIST : ADD_FRIEND_ADD_DIALOG
      }).then((res) => {
        this.friend_lock = false
        if (res.data.status === 'ok') {
          if (!noToast) {
            this.SET_ADD_FRIEND_MODAL(false)
            this.$toast.success('发送成功')
          }
        }
      }).catch(err => {
        this.$toast.error(`添加失败,${err}`)
      })
    },
    hideRoom(id) {
      this.$set(this.room_hide_bl, id, this.room_hide_bl[id] ? false : true)
    },
    hideFriendBlock(type) {
      const hide_friend_types = this.setting_data.hide_friend_types || {}
      hide_friend_types[type] = !hide_friend_types[type]
      this.SET_SETTING_DATA_PARAM({
        hide_friend_types
      })
      if (type === 'recommend' && !this.isFristExpendRecommend) {
        this.isFristExpendRecommend = true
        this.getRecommendFriendUntilCanScroll()
      }
    },
    getChannelMutiDes(channel) {
      if ((channel.count - channel.friends.length) <= 0) {
        return `<span class="friend_muti_des_channel_name">${channel.channel_name}</span>` + ' 频道语音中'
      } else {
        let str = '与', l = []
        if (channel.with_me) {
          l.push('我')
        }
        if (channel.count - channel.friends.length - (channel.with_me ? 1 : 0) > 0) {
          l.push(`其他${channel.count - channel.friends.length - (channel.with_me ? 1 : 0)}人`)
        }
        str += l.join('、')
        str += ' ' + `<span class="friend_muti_des_channel_name">${channel.channel_name}</span>` + ' 频道语音中'
        return str
      }
    },
    handleClickRecentMsg (friend) {
      if (!friend) return
      if (this.cur_private_user.user_id == friend.user_id) {
        EventBus.$emit('Hide_Private_IM')
        return
      }
      if (friend.new_msg_count) {
        const target = this.recent_msg_list.find(item => item.user_id == friend.user_id)
        if (target) {
          if (target.user_id !== NEW_OFFICIAL_MESSAGE_ID.heychat_interaction_msg) {
            this.SET_RECENT_MSG_COUNT(this.recent_msg_count - friend.new_msg_count)
            target.new_msg_count = 0
            this.SET_RECENT_MSG_LIST(this.recent_msg_list)
          }
        }
      }
      this.localPrivateChatHandler(friend)
    },
    async handleClickMember (event, attrElement, user_id) {
      if(!await checkLoginStatusAsync()){
        EventBus.$dynamic('Login')
        return
      }
      if (this._isDestroyed) return
      let user = null
      switch (this.active_sidebar_tab) {
        case 'room':
          const members = this.$refs['room-members'].getShowMemberList()
          user = members.find(item => item.user_id == user_id)
          break
        case 'friends':
          user = this.friends_map[user_id]
          // 没有的话判断是不是推荐好友
          if (!user && attrElement.classList.contains('cpt-recommend-user')) {
            user = this.recommend_friends.find(item => item.user_id == user_id)
          }
          // 没有的话判断是不是Steam好友
          if(!user && attrElement.classList.contains("cpt-steam-friend")) {
            const res = await getUserInfo({ heybox_id: user_id })
            if(res.data.status === 'ok') {
              user = res.data?.result.info
            }
          }
          break
        case 'recent-msg':
          let msg_item = this.recent_msg_list.find(item => item.user_id == user_id)
          msg_item && this.handleClickRecentMsg(msg_item)
          return
        default:
          break
      }
      if (user) {
        event._currentTarget = event.target
        const origin = this.active_sidebar_tab === 'room'
        this.localUserCardMenuHandler(event, 'friend', deepCopy(user), user_id, origin)
      }
    },
    async handleUserContextMenu (event, attrElement, user_id) {
      event.preventDefault()
      if(!await checkLoginStatusAsync()){
        EventBus.$dynamic('Login')
        return
      }
      if (this._isDestroyed) return
      let user = null
      switch (this.active_sidebar_tab) {
        case 'room':
          const members = this.$refs['room-members'].getShowMemberList()
          user = members.find(item => item.user_id == user_id)
          let in_channel_user = this.cur_channel_data.members?.find((u) => u.user_id == user.user_id)
          if (in_channel_user) {
            user.verified = in_channel_user.verified
            user.same_audio_channel = true
          }
          this.roomListContextMenuHandler(event, user)
          return
        case 'friends':
          user = this.friends_map[user_id]
          // 没有的话判断是不是推荐好友
          if (!user && attrElement.classList.contains('cpt-recommend-user')) {
            user = this.recommend_friends.find(item => item.user_id == user_id)
          }
          // 没有的话判断是不是Steam好友
          if(!user && attrElement.classList.contains("cpt-steam-friend")) {
            const res = await getUserInfo({ heybox_id: user_id })
            if(res.data.status === 'ok') {
              user = res.data?.result.info
            }
          }
          EventBus.$emit('User_Menu:contextmenu', event, 'friend', user)
          return
        case 'recent-msg':
          const recent = this.recent_msg_list.find(item => item.user_id == user_id)
          if (getOfficialMessageIds.includes(recent.user_id)) {
            return
          }
          EventBus.$emit('User_Menu:contextmenu', event, 'friend', recent)
          return
        default:
          break
      }
    },
    localUserCardMenuHandler(event, type, user, key, origin) {
      if (event.shiftKey && this.hasJoinChannel && this.active_sidebar_tab === 'room') {
        // todo 调用RichTextInput组件中的insertHTML方法
        // insertHTML(`<a class="at" style="color:@d-bd-tx" contenteditable="false" data-remind-user-id="${id || 0}" data-type='1'>@${id:heybox_id}&#xFEFF;</a> `)
        // console.log('@用户')
      } else {
        clearTimeout(this._clickTimeout)
        if (!event._currentTarget) {
          event._currentTarget = event.currentTarget
        }
        this._clickTimeout = setTimeout(() => {
          EventBus.$emit('User_Menu:card', event, type, user, { key, origin });
        }, 200)
      }
    },
    localPrivateChatHandler(user) {
      EventBus.$emit('User_Menu:card', false)
      clearTimeout(this._clickTimeout)
      const fromRoom = this.active_sidebar_tab === 'room'
      this.privateChatHandlerV2(user, false, fromRoom)
    },
    handleChatList(result) {
      let new_recent_msg_list = this.recent_msg_list;
      new_recent_msg_list.forEach(chat => {
        let target = this.friends_map[chat.user_id]
        chat.state = target ? target.state : 1
      })
      this.SET_RECENT_MSG_LIST(new_recent_msg_list);
    },
    openChatHandler(user_id) {
      this.SET_SHOW_FRIEND_SIDEBAR(true)
      this.SET_ACTIVE_SIDEBAR_TAB('recent-msg')
      let index = this.recent_msg_list.findIndex(item => item.user_id == user_id)
      if (index !== -1) {
        this.handleClickRecentMsg(this.recent_msg_list[index])
      } else {
        this.init_open_user_id = user_id
      }
    },

    async roomListContextMenuHandler(event, member) {
      let source_position = this.$permission.calcUserPosition(this.cur_my_roles, this.user_info.user_id)
      let identityManage = []
      let ignoreList = [ROLE_TYPES.everyone, ROLE_TYPES.tourist]
      let hasRole = false
      this.cur_roles_list.forEach(role => {
        if(ignoreList.includes(role.type) || source_position >= role.position) return
        hasRole = true
        let gradient = ''
        if (role.color_list && role.color_list.length == 2) {
          const colors = role.color_list.map(color => decimalToHexColor(color))
          gradient = `linear-gradient(90deg, ${colors[0]} 0%, ${colors[1]} 100%)`
        }
        let data = {
          label: role.name,
          icon: role.icon ? '' : 'icon-admin',
          image: role.icon,
          gradient,
          color: gradient ? '' : decimalToHexColor(role.color),
          selected: member.roles && member.roles.includes(role.id),
          confirm: ()=> {
            addRoleUsers({}, {
              to_user_id: member.user_id,
              department_id: role.department_id,
              role_id: role.id,
              room_id: role.department_id,
            }).then(()=>{
              EventBus.$emit('Refresh_Member_List')
            })
          },
          cancel: ()=> {
            revokeRoleFromUsers({}, {
              to_user_id: member.user_id,
              department_id: role.department_id,
              role_id: role.id,
              room_id: role.department_id,
            }).then(()=>{
              EventBus.$emit('Refresh_Member_List')
            })
          }
        }
        identityManage.push({
          component: 'menu-selector',
          data,
        })
      })
      EventBus.$emit('User_Menu:contextmenu', event, 'channel', member, {
        adminMenu: await getUserAddminMenu({ member }),
        user_card_type: 'friend'
      })
    },
    // 未读消息右键菜单
    unreadMenuHandler (event, data) {
      if (data.user_id === NEW_OFFICIAL_MESSAGE_ID.heychat_sys_notify) {
        let isSysNotifyTop = this.top_friend_id.includes(NEW_OFFICIAL_MESSAGE_ID.heychat_sys_notify)
        this.$contextmenu({
          groups: [
            {
              items: [
                {
                  component: 'menu-button',
                  data: {
                    label: isSysNotifyTop ? '取消置顶' : '置顶',
                  },
                  onClick: () => {
                    setSysNotifyTop({}, {
                      is_top: isSysNotifyTop ? 0 : 1
                    }).then(res => {
                      if (res.data.status === 'ok') {
                        this.getTopFriendList()
                      }
                    })
                  }
                },
              ]
            },
          ],
          event,
        })
      }
    },
    roomMemberCnt(room) {
      let cnt = 0
      room.channels.forEach(channel => {
        if(channel.friends) {
          cnt += channel.friends.length || 0
        }
      })
      return cnt
    },
    resortMemberList() {
      this.flatMemberByRole()
    },
    changeWithMe(channel_id, bl) {
      if (!channel_id) return

      for (let index in this.friends_data.rooms) {
        let room = this.friends_data.rooms[index]
        if (room.channels) {
          let channel = room.channels.find(channel => channel.channel_id === channel_id)
          if (channel) {
            if (channel.with_me !== bl) {
              this.$set(channel, 'with_me', bl)
              this.$set(channel, 'count', channel.count + (bl ? 1 : -1))
              if (isSingleUser(room.channels)) {
                this.friends_data.rooms.splice(index, 1)
                this.friends_data.single_user_rooms.push(room)
                this.friends_data.single_user_rooms.sort(this.friendSortFunc)
              }
            }
            return
          }
        }
      }

      for (let index in this.friends_data.single_user_rooms) {
        let room = this.friends_data.single_user_rooms[index]
        if (room.channels) {
          let channel = room.channels.find(channel => channel.channel_id === channel_id)
          if (channel) {
            if (channel.with_me !== bl) {
              this.$set(channel, 'with_me', bl)
              this.$set(channel, 'count', channel.count + (bl ? 1 : -1))
              if (!isSingleUser(room.channels)) {
                this.friends_data.single_user_rooms.splice(index, 1)
                this.friends_data.rooms.push(room)
                this.friends_data.rooms.sort(this.friendSortFunc)
              }
            }
            return
          }
        }
      }
    },
    clearPrivateUnread() {
      this.$query({
        config: {
          title: '确认清除所有未读消息提醒？',
          cancel: {
            text: '取消'
          },
          confirm: {
            text: '确定'
          }
        },
        confirmCB: () => {
          updatePrivateReadState({}, {
            all: true
          })
          this.SET_RECENT_MSG_COUNT(0)
          if (this.active_sidebar_tab === 'recent-msg') {
            let _recent_msg_list = JSON.parse(JSON.stringify(this.recent_msg_list))
            _recent_msg_list.forEach(msg => msg.new_msg_count = 0)
            this.SET_RECENT_MSG_LIST(_recent_msg_list)
            
            clearPostUnread()
            this.SET_POST_MSG_UNREAD({
              award: 0,
              comment: 0,
              at: 0
            })
          }
          
          if (process.env.IS_CLIENT) {
            // 清除tray中所有最近消息内的类型，帖子&私聊&消息通知&系统消息
            window.electronAPI.clearTrayMessageByType(['post', 'private', 'notify', 'official'])
          }
        }
      })
    },
    handleAddFriend(){
      this.SET_ADD_FRIEND_MODAL(true)
    },
    
    getSteamFriendsList() {
      getUserGameIds({
        user_id: this.user_info.user_id
      }).then(res => {
        if(res.data.status === 'ok') {
          const steam_id = res.data.result.game_ids.steam_id || ""
          if(steam_id) this.SET_STEAM_ID(steam_id)
        }
      })

      if(!(this.user_account_settings.allow_steam_nethook === 1 && steam.isRunEnv())) return;
      this.steamTimer = setInterval(this.handlerSteamFriendsList.bind(this), 20 * 1000)
    },
    handlerSteamFriendsList() {
      if((this.steamNetHookNum++) >= steam.MAX_NETHOOK_NUM) {
        clearInterval(this.steamTimer)
        steam.destory()
      }
      if(this.steam_id) {
        steam.isSend = true
        steam.sendSteamFriendByInject(this.steam_id);
        steam.sendSteamPersonaStateByInject(this.steam_id)
      } else {
        if(this.steamTimer) {
          clearInterval(this.steamTimer);
          this.steamTimer = null;
        }
      }
    },
    async fetchSteamFriends(data) {
      if(this.steamTimer) {
        clearInterval(this.steamTimer);
        this.steamTimer = null;
      }
      if(!(data && Array.isArray(data))) return;

      const args = data.map(item => ({ steam_id: item.steam_id, appid: item.appid }))
      const res = await getSteamFriends({ _notip: true }, { steam_states: args })
      if (this._isDestroyed) return
      if (res.data.status === 'ok') {
        const result = res.data.result?.list
        return result
      }
    },
    async changeSteamFriends(data) {
      try {
        const result = await this.fetchSteamFriends(data)
        const heyboxList = [];
        const heyboxKeys = ['online_friends', 'offline_friends', 'rooms', 'single_user_rooms'];
        if (this._isDestroyed) return
        heyboxKeys.forEach(key => {
          const list = this.friends_data[key];
          if (!list) return;

          if (key === 'single_user_rooms') {
            list.forEach(f => {
              f.channels.forEach(c => heyboxList.push(...c.friends));
            });
          } else {
            heyboxList.push(...list);
          }
        });

        const resultListSlice = steam.formatResultList(result, heyboxList)
        steam.isInit = true
        this.friends_data.steam_friends = resultListSlice;
      } catch (error) {
        console.log(error)
      }
    },
    async changePartSteamFriends(data) {
      try {
        // 如果是在线状态修改直接修改即可，如果是游戏状态变化，请求接口
        const modifyList = []
        data.forEach(item => {
          const friend = steam.resultList?.find(f => f.steam_id === item.friendid)
          if (friend) {
            if (friend.appid !== item.gameid) modifyList.push(item)
          }
        })

        const formatModifyList = modifyList.map(item => ({ steam_id: item.friendid, appid: item.gameid + "" }))
        if(formatModifyList.length > 0) {
          const result = await this.fetchSteamFriends(formatModifyList)
          if (this._isDestroyed) return
          result.forEach(item => {
            const friend = steam.resultList?.find(f => f.steam_id === item.steam_id)
            const modify = formatModifyList?.find(m => m.steam_id === item.steam_id)
            if (friend) {
              if(modify) friend.appid = modify.appid + ""
              friend.game_name = item.game_name
            }
            else steam.resultList.push(item)
          })
        }
        
        this.friends_data.steam_friends = steam.formatResultList()
      } catch (error) {
        console.log(error)
      }
    },
    getSteamFriendsMessage(data, otherSteamid) {
      const friend = this.friends_data.steam_friends.find(f => f.steam_id === otherSteamid)
      if(friend) {
        friend.isInvite = true;
        steam.invitedList.push(otherSteamid)
      }
    },
    changeSettingSteamNetHook(value) {
      if(value) {
        steam.init(true)
        this.getSteamFriendsList()
      } else {
        steam.destory()
        this.$set(this.friends_data, 'steam_friends', [])
      }
    },
    switchSteamAccount() {
      steam.destory();
      this.friends_data.steam_friends = []
    }
  },
  components: {
    Avatar,
    RedNum,
    NoFriendsWrapper,
    RecentMsgs,
    RoomMembers,
    FriendsMembers
  }
}
</script>

<style lang="scss">
@import "_css/skeleton.scss";

.sidebar {
  transition: background .2s ease-out;
  .friends-sidebar {
    &.friends-in-room {
      .online-cnt {
        left: 153px;
      }
      .recent-red-num {
        left: 227px;
      }
    }
    .friends-tab-top {
      &::after {
        content: '';
        width: calc(100% + 16px);
        height: 1px;
        background-color: $d-op-1;
        position: absolute;
        left: -16px;
        bottom: 1px;
      }
    }
    .friends-tab-bar {
      transition: transform .3s cubic-bezier(.645,.045,.355,1);
    }
    .friends-tab-item {
      &:last-of-type {
        padding-right: 0;
      }
      &:first-of-type {
        padding-left: 0;
      }
      &.active, &:hover {
        color: $d-tx-1;
        font-weight: 700;
      }
    }
    .has-friend-wrapper {
      height: 100%;
      position: relative;
      display: flex;
      flex-direction: column;
    }
    .scroll-list {
      overflow-y: auto;
      overflow-y: overlay;
      height: 100%;
    }
    .online-friend, .offline-friend {
      .friend-list-wrapper.hide {
        max-height: 0!important;
        overflow: hidden;
      }
    }
    .input-wrapper {
      flex-shrink: 0;
      display: flex;
      width: 100%;
      transition: transform .3s cubic-bezier(0, 0, 0.58, 1);
      position: relative;
      &.single {
        width: 100%;
      }
      &.no-tabs {
        &::after {
          content: '';
          height: 1px;
          background-color: $d-op-1;
          position: absolute;
          left: 0;
          right: 0;
          bottom: 1px;
        }
        .search-group {
          margin-top: 10px;
          padding-bottom: 10px;
        }
      }
      .search-group {
        flex: 1;
        padding: 0px 8px 8px;
        margin: 12px 8px 0px;
        display: flex;
        flex-direction: row;

        &:not(:first-of-type) {
          margin-left: 8px;
        }
        &.warn {
          border: 2px solid $d-bd-tx;
          border-radius: 8px;
          padding: 6px;
        }
        .cpt-search-input {
          height: 32px;
        }

        .add-friend-btn {
          width: 32px;
          height: 32px;
          flex-shrink: 0;
          background-color: $d-op-1;
          border-radius: 5px;
          color: $d-op-4;
          margin-left: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          .icon-add-bold {
            font-size: 14px;
          }
        }
      }
    }

    .recent-scroll-container {
      padding-right: 0;
      .recent-msg-item {
        padding: 4px 0;
        margin: 0;
        .cpt-friend-item {
          height: 50px;
          padding-right: 8px;
        }
      }
    }

    .cpt-title-group {
      .cpt-chat-form-button {
        width: fit-content;
        height: 24px;
        font-size: 12px;
        padding: 0 9px;
        .iconfont {
          font-size: 12px;
        }
      }
    }
    .cpt-chat-room-avatar {
      margin-right: 8px;
      flex-shrink: 0;
    }
    .split {
      height: 11px;
      padding: 5px 8px;
      position: relative;
      &::after {
        content: '';
        position: absolute;
        width: 248px;
        left: 50%;
        height: 50%;
        transform: translate(-50%, -50%);
        height: 1px;
        background: $d-op-1;
      }
    }
    .recent-red-num {
      position: absolute;
      top: 10px;
      left: 147px;
      z-index: 2;
    }
    .online-cnt {
      height: 22px;
      text-align: center;
      position: absolute;
      top: 13px;
      left: 73px;
      line-height: 22px;
      color: $d-ol-tx;
      border-radius: 16px;
      font-size: 18px;
      transform: scale(.5);
      transform-origin: top left;
    }
  }
}

.friend-chat-list-leave-active {
  position: absolute;
}
.friend-chat-list-move{
  transition: all .2s;
}
.virtual-list-wrapper {
  .member-virtual-list {
    padding-left: 8px;
    height: 100%;
    position: relative;
    overflow-y: scroll!important;
  }
}

.friend_muti_des_channel_name {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow-x: hidden;
}
</style>